<template>
  <article class="Survey" :class="{ 'Survey_show': isShow }" @mouseover="onMouseEnter" @mouseleave="onMouseLeave">
    <h4>{{ data.title }}</h4>
    <figure class="Survey_illustration" v-if="data.illustration">
      <div class="Survey_illustration_image Survey_illustration_image_bodymovin" v-if="data.illustration.endsWith('.json')" ref="bodymovin" :style="{ opacity: lottieLoaded ? 1 : 0 }"></div>
      <img class="Survey_illustration_image" :src="data.illustration" v-else/>
    </figure>
  </article>
</template>

<script>
  import scrollUpdate from '@/mixins/scrollUpdate'
  import lottie from 'lottie-web'

  export default {
    name: "Survey",
    mixins: [ scrollUpdate ],
    props: [ 'data' ],
    data() {
      return {
        isShow: false,
        isHover: false,
        anim: null,
        lottieLoaded: false
      }
    },
    methods: {
      onVisible()
      {
        this.isShow = true
      },
      onUnVisible()
      {
        if(this.anim)
        {
          this.anim.pause()
        }
      },
      onMouseEnter()
      {
        if(!this.isHover && this.anim)
        {
          this.isHover = true
          this.anim.play()
        }
      },
      onMouseLeave()
      {
        if(this.isHover && this.anim)
        {
          this.isHover = false
          this.anim.pause()
        }
      }
    },
    mounted()
    {
      if(this.data.illustration && this.data.illustration.endsWith(".json"))
      {
        this.anim = lottie.loadAnimation({
          container: this.$refs.bodymovin,
          renderer: 'svg',
          loop: true,
          autoplay: false,
          path: this.data.illustration
        });

        this.anim.addEventListener('DOMLoaded', () => { this.lottieLoaded = true; this.anim.pause() })
      }
    }
  }
</script>

<style lang="stylus" scoped>
.Survey

  position relative 
  background: #FFFFFF;
  // height 100%
  box-shadow: 0 2px 24px 0 rgba(0,0,0,0.10);
  border-radius: 5px;
  // border-left 4px solid $red
  cursor pointer
  padding 40px 25px
  box-sizing border-box
  width 100%
  min-height 260px
  max-width 385px
  text-align center
  margin-right 20px
  display flex
  flex-direction column
  overflow hidden
  align-items center
  justify-content space-between
  transform-origin center bottom
  transition box-shadow 0.6s $ease, transform 1.4s 0.2s $back, opacity 0.7s 0.2s $ease

  @media $medium

    max-height 120px
    opacity 0.3
    transform scale(0.9)

  &:after

    content ''
    position absolute
    top 0px
    left 0px
    height 100%
    background-color $blue
    width 4px
    transition 0.7s $ease

    @media $medium

      width 100%

  &_show

    transform scale(1)
    opacity 1

    &:after

      width 4px

  &:hover

    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.22);

    img

      transform scale(1.15)

  @media $medium

    margin-bottom 10px
    min-height 100px
    max-width auto
    flex-direction row
    text-align left
    padding 30px 25px

  figure

    @media $medium

      position absolute
      top 50%
      transform translateY(-50%)
      right -30px

  img, figure

    // height 110px
    margin auto auto 0px auto
    // transform scale(1.2)

    @media $medium

      margin auto auto auto auto
      height auto

    .Survey_illustration_image_bodymovin

      width 200px
      transform scale(1.2)

      @media $medium

        width 150px
        transform scale(1)

  img

    height 110px
    transition 0.6s $ease

    @media $medium

      height 70px
      left -15px
      position relative

  h4

    margin 0px auto auto auto
    width 100%

    @media $medium

      font-size 14px
      z-index 2
      margin auto auto auto 0px
      line-height 17px
      position absolute
      left 25px
      top 50%
      transform translateY(-50%)
      width 65%

.ie

  .Survey

    img

      margin-top 20px
</style>